import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SlidingPane from "react-sliding-pane";
import { isDesktop } from "utils/device-detect";
import SubscriptionCartHeader from "./header";
import SubscriptionCartBody from "./body";
import { TOGGLE_SUBS_CART } from "utils/action-types";
import SubscriptionCartFooter from "./footer";

const SubscriptionCart = ({ path }) => {
	const { subscriptionId, isCartOpen, pendingChanges } = useSelector((state) => state.account.subscription);
	const desktop = isDesktop();
	const dispatch = useDispatch(); 

	useEffect(() => {
		let body = document.body.classList;
		body.toggle("ReactModal__Body--open", isCartOpen);
	}, [isCartOpen]);

	if (!subscriptionId) return null;

	const shouldKeepCartOpen = path === "/account/subscription" && pendingChanges;

	const onRequestClose = () => {
		if (shouldKeepCartOpen) return;

		dispatch({ type: TOGGLE_SUBS_CART });
	};

	return (
		<SlidingPane
			from="right"
			width={desktop ? "360px" : "90%"}
			shouldCloseOnEsc={!shouldKeepCartOpen}
			overlayClassName="z-50"
			isOpen={isCartOpen}
			hideHeader
			onRequestClose={onRequestClose}
		>
			<div className="flex flex-col size-full">
				<SubscriptionCartHeader shouldKeepCartOpen={shouldKeepCartOpen}/>
				<SubscriptionCartBody /> 
				<SubscriptionCartFooter />
			</div>
		</SlidingPane>
	);
};

export default SubscriptionCart;
